import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'question-description',
    templateUrl: './question-description.component.html',
    styleUrls: ['./question-description.component.scss'],
    standalone: false
})
export class QuestionDescriptionComponent implements OnInit {
  @Input() titleDir: string = 'left';
  @Input() subTitleDir: string = 'left';
  @Input() titleStyle: any = {};
  @Input() subTitleStyle: any = {};
  @Input() title: string;
  @Input() subTitle: string;
  constructor() {}

  ngOnInit() {}
}
